import { SEND_TIMELINE } from '../../../shared/utils/constants';

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Esse campo não pode ficar vazio';
  }
  if (!values.shortName) {
    errors.shortName = 'Esse campo não pode ficar vazio';
  }
  if (!values.titleTimeline) {
    errors.titleTimeline = 'Esse campo não pode ficar vazio';
  }
  if (!values.order) {
    errors.order = 'Esse campo não pode ficar vazio';
  }
  if (!values.itemValue && values.calculatePeriod) {
    errors.itemValue = 'Esse campo não pode ficar vazio';
  }
  if (values.iconTablet) {
    if (Object.keys(values.iconTablet).length === 0) {
      errors.iconTablet = 'Esse campo não pode ficar vazio';
    }
  }
  if (values.iconTimeline) {
    if (Object.keys(values.iconTimeline).length === 0) {
      errors.iconTimeline = 'Esse campo não pode ficar vazio';
    }
  }
  if (values.requestTime) {
    if (!values.requestTimeType) {
      errors.requestTimeType = 'Esse campo não pode ficar vazio';
    }
  }
  if (values.foodItem) {
    if (!values.typeOfMeal) {
      errors.typeOfMeal = 'Esse campo não pode ficar vazio';
    }
  }
  if (values.needsApproval) {
    if (!values.approverProfile) {
      errors.approverProfile = 'Esse campo não pode ficar vazio';
    }
  }

  if (values.sendTimeline) {
    if (values.sendTimeline.value !== SEND_TIMELINE.NO && !values.description) {
      errors.description = 'Esse campo não pode ficar vazio';
    }
  }
  return errors;
};

export default validate;
